import MODULE_NAME from './constants';

export const SET_SETTINGS = `${MODULE_NAME}/SET_SETTINGS`;

export const setSettings = (settings) => ({
  type: SET_SETTINGS,
  payload: { settings },
});
